import { authOptions } from '@/app/api/auth/[...nextauth]/config';
import {
  ApolloClient,
  ApolloLink,
  DefaultOptions,
  InMemoryCache,
} from '@apollo/client';
import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import { HASURA_HOST } from '@treyd-io/core/constants/api';
import { PROTOCOL } from '@treyd-io/core/constants/settings';
import { createUploadLink } from 'apollo-upload-client';
import { getServerSession } from 'next-auth';
// Adds messages only in a dev environment
loadDevMessages();
loadErrorMessages();
const httpLink = createUploadLink({ uri: `${PROTOCOL.http}://${HASURA_HOST}` });

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
  mutate: {
    errorPolicy: 'all',
  },
};

const getAuthLink = (accessToken: string) =>
  new ApolloLink((operation, forward) => {
    // Use the setContext method to set the HTTP headers.
    operation.setContext({
      headers: {
        authorization: accessToken ? `Bearer ${accessToken}` : '',
      },
    });

    // Call the next link in the middleware chain.
    return forward(operation);
  });

async function getAccessToken() {
  const session = await getServerSession(authOptions());
  return session?.user?.accessToken;
}

export const getClient = async () => {
  const accessToken = await getAccessToken();
  const client = new ApolloClient({
    link: getAuthLink(accessToken as string).concat(httpLink), // Chain it with the HttpLink
    cache: new InMemoryCache(),
    defaultOptions: defaultOptions,
  });
  return client;
};

export const getApolloClient = async (accessToken: string) => {
  const client = new ApolloClient({
    link: getAuthLink(accessToken as string).concat(httpLink), // Chain it with the HttpLink
    cache: new InMemoryCache(),
    defaultOptions: defaultOptions,
  });
  return client;
};
